import React from "react";
import { Spinner } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";

export default function Loading() {
  return (
    <ShimmerTable row={10} col={5} />
  )
}
